























import { Component, Inject, Prop, Mixins } from 'vue-property-decorator';
import { AxiosInstance } from 'axios';
import { LoaderMixin } from '@/pages/profile/mixins';
import { competencesService, MapedCompetencesType } from '@/services';
import isArrayNotEmpty from '@/tools/isarraynotempty';
import { CompetenceCard } from '@/components/parts/competences';
import { AppHeading, CardtabLayout } from '@/uikit';

@Component({
  components: {
    AppHeading,
    CardtabLayout,
    CompetenceCard,
  },

  inheritAttrs: false,
})
export default class Competence extends Mixins(LoaderMixin) {
  @Inject() $api: AxiosInstance;

  @Prop({ type: String, default: '' })
  readonly id!: string;

  competence: MapedCompetencesType = [];
  error: boolean = false;

  async mounted() {
    try {
      const { data } = await competencesService(this.$api).getCompetences({
        event_id: this.id,
      });

      if (isArrayNotEmpty(data)) this.competence = data;
      this.setStatus('success');
    } catch (err) {
      this.error = true;
      this.setStatus('success');
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/professions/card/competence/Competence.vue